<script>
    import '../project-detail-preview/projectDetailPreview.css';
    import {projectDetail} from "../../../../store";
    import {BASE_URL} from "../../../../constants/constants";
    import SvelteMarkdown from "svelte-markdown";
    import {IMAGE_STRING_REGEX, prependUrlToImages} from "../../../../utils";

    let source

    projectDetail.subscribe( () => {
        if($projectDetail.token_details){
            if($projectDetail.token_details.match(IMAGE_STRING_REGEX)) {
                source = prependUrlToImages($projectDetail.token_details, BASE_URL)
            } else {
                source = $projectDetail.token_details;
            }
        }
    })
</script>
<div class="detail-preview">
    {#if source}
        <SvelteMarkdown {source} />
    {/if}
</div>
